// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__U1PwW","resendInfoText":"OnGoingPaymentBox_resendInfoText__3bkTh"};